<template>
  <div id="app">
    <div v-if="$store.state.appInfo.site_state == 1">


      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" :key="$route.name" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" :key="$route.name" />
    </div>
    <div v-if="$store.state.appInfo.site_state == 0" style="box-sizing: border-box; padding: 30px; fong-size: 26px">{{ $store.state.appInfo.repair_tips }}</div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
    };
  },
  created() {
    let that = this;
    that.getApp();
  },
  methods: {
   
    getApp() {
      let that = this;
      that.$apiFun.post('/api/app', {}).then(res => {
        if (res.code == 200) {
          localStorage.setItem('appInfo', JSON.stringify(res.data));
          that.$store.commit('changappInfo');
          document.getElementsByTagName('title')[0].innerText = that.$store.state.appInfo.title;
        }
      });
    },
  },
  mounted() {},
};
</script>

<style>
.sdfdds .el-input__inner {
  background: none !important;
}
.sdfdds .el-radio-button__inner {
  background: none !important;
}
.sdfdds .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #fecb4d !important;
}
.s11ss .el-pagination button:disabled {
  color: #c0c4cc;
  cursor: not-allowed;
  background: none !important;
}
.deposit-container .el-input--suffix .el-input__inner {
  /* padding-right: 30px; */
  background: none;
  border: none;
  height: 100%;
  font-family: PingFangSC-Regular, Helvetica, 微软雅黑, serif;
  color: #666666;
  font-size: 16px;
}
.deposit-container .el-input {
  height: 100%;
}
.deposit-container .el-input__inner {
  padding-left: 0;
}
.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #fff;
  background-color: #fecb4d;
  border-color: #fecb4d;
  -webkit-box-shadow: -1px 0 0 0 #fecb4d;
  box-shadow: -1px 0 0 0 #fecb4d;
}
</style>



// WEBPACK FOOTER //
// src/App.vue